var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main_wrap" }, [
      _c("div", { staticClass: "welcomme_wrap" }, [
        _vm.$i18n.locale == "ko_KR"
          ? _c("div", { staticClass: "message" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("sdl.rwd.message.main.welcomeMsg01", [
                      _vm.userInfo.userName
                    ])
                  )
              ),
              _c("br"),
              _vm._v(" "),
              _c("label", [
                _vm._v(_vm._s(_vm.$t("sdl.rwd.message.main.welcomeMsg02")))
              ]),
              _vm._v(
                _vm._s(_vm.$t("sdl.rwd.message.main.welcomeMsg03")) + "\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$i18n.locale == "en_US"
          ? _c("div", { staticClass: "message" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("sdl.rwd.message.main.welcomeMsg01", [
                      _vm.userInfo.userNameEn
                    ])
                  )
              ),
              _c("br"),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("sdl.rwd.message.main.welcomeMsg03")) +
                  "  "
              ),
              _c("label", [
                _vm._v(_vm._s(_vm.$t("sdl.rwd.message.main.welcomeMsg02")))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "router-link",
              { staticClass: "btn_gcrm", attrs: { to: "/about/GCRM" } },
              [_vm._v("GCRM " + _vm._s(_vm.$t("sdl.gcrm.main.what.is")))]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mainCon_wrap" }, [
        _c("div", { staticClass: "main_leftCon" }, [
          _c(
            "div",
            { class: _vm.isViewAll ? "quick_wrap open" : "quick_wrap" },
            [
              _c("div", { staticClass: "main_tit" }, [_vm._v("Quick Link")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.swipers, function(menu, index) {
                  return index < 4 && menu.iconClass != ""
                    ? _c(
                        "li",
                        {
                          class: menu.iconClass,
                          on: {
                            click: function($event) {
                              return _vm.setExternalUrl(menu)
                            }
                          }
                        },
                        [
                          _c("p", { staticClass: "quickicon" }),
                          _vm._v(" "),
                          _c("p", { staticClass: "quick_txt" }, [
                            _vm._v(_vm._s(_vm.getLabel(menu)))
                          ])
                        ]
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "view_quick" }, [
                _c(
                  "ul",
                  _vm._l(_vm.swipers, function(menu, index) {
                    return index > 3 && menu.iconClass != ""
                      ? _c(
                          "li",
                          {
                            class: menu.iconClass,
                            on: {
                              click: function($event) {
                                return _vm.setExternalUrl(menu)
                              }
                            }
                          },
                          [
                            _c("p", { staticClass: "quickicon" }),
                            _vm._v(" "),
                            _c("p", { staticClass: "quick_txt" }, [
                              _vm._v(_vm._s(_vm.getLabel(menu)))
                            ])
                          ]
                        )
                      : _vm._e()
                  }),
                  0
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "quick_btn_wrap",
              on: {
                click: function($event) {
                  return _vm.viewAllMenu()
                }
              }
            },
            [
              _c(
                "div",
                { class: _vm.isViewAll ? "quick_btn close" : "quick_btn more" },
                [
                  !_vm.isViewAll
                    ? _c("a", { attrs: { id: "quick_more" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.rwd.btn.more")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isViewAll
                    ? _c("a", { attrs: { id: "quick_more" } }, [
                        _vm._v(_vm._s(_vm.$t("sdl.rwd.btn.close")))
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "banner_wrap" }, [
            _c("div", { staticClass: "ITvoc" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "http://itvoc.sec.samsung.net",
                    target: "_blank"
                  }
                },
                [
                  _c("p", { staticClass: "banner_ITvoc_tit" }, [
                    _vm._v(_vm._s(_vm.$t("sdl.gcrm.common.goToItVocHome")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("label", [
                _vm._v(_vm._s(_vm.$t("sdl.gcrm.common.goToVocMain")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "main_rightCon" }, [
          _c("div", { staticClass: "notice_wrap" }, [
            _c(
              "div",
              { staticClass: "main_tit" },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("sdl.main.message.notice")) +
                    "\n            "
                ),
                _c(
                  "router-link",
                  {
                    staticClass: "btn more",
                    attrs: { to: "/about/notice/list" }
                  },
                  [_vm._v(_vm._s(_vm.$t("sdl.gcrm.common.viewMore.details")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "news-list" },
              _vm._l(_vm.gridList, function(item) {
                return _c(
                  "li",
                  {
                    key: item.number,
                    class: {
                      visited: _vm.$getVisited(_vm.tableId, item.noticeId)
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "state-label General",
                        class: {
                          primary: Number(item.importantYn) ? true : false
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              !Number(item.importantYn)
                                ? _vm.$t("sdl.gcrm.common.general")
                                : _vm.$t("sdl.gcrm.common.important")
                            ) +
                            "\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tit" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-truncate",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.getNoticeItem(item.noticeId)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(item.title) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "date" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormat")(
                            item.firstRegDatetime,
                            _vm.$t("data-format.date.ymd")
                          )
                        )
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _vm.userInfo.compCode !== "PC2"
            ? _c("div", { staticClass: "Request" }, [
                _c("div", { staticClass: "Request_tit_warp" }, [
                  _c("span", { staticClass: "Request_tit" }, [
                    _vm._v(_vm._s(_vm.$t("sdl.gcrm.common.requestForData")))
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "Request_infor",
                    attrs: {
                      "data-tooltip": _vm.$t("sdl.rwd.message.main.tooltipMsg")
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "Request_btn_wrap" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-primary btn-md",
                        attrs: { to: "/voc/datareq/dataWrite" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("sdl.gcrm.common.requestData")) +
                            "\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-primary btn-md",
                        attrs: { to: "/voc/datareq/dataList" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("sdl.gcrm.common.requestStatus")) +
                            "\n              "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        ref: "keyParamFormMain",
        attrs: { name: "keyParamFormMain", method: "post", target: "newWin2" }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.key_param,
              expression: "key_param"
            }
          ],
          attrs: { type: "hidden", name: "key_param" },
          domProps: { value: _vm.key_param },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.key_param = $event.target.value
            }
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13966bdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13966bdc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/MainIndexPage.vue
// module id = null
// module chunks = 